<template>
  <div class="mine-project" :class = "{'clear-header':isWechatBrowser}">
    <my-header class="top-title" v-if="!isWechatBrowser" title="我的项目" :showBack="true"></my-header>
    <div class="option-labels" style="margin-top: -0.1rem; justify-content:space-around;">
      <div v-if="isLabelNum == 4" class="option-item selected">未完工</div>
      <div v-if="isLabelNum != 4" class="option-item" @click="isLabel(4)">未完工</div>
      <!-- <div v-if="isLabelNum == 8" class="option-item selected">待竣工</div>
      <div v-if="isLabelNum != 8" class="option-item" @click="isLabel(8)">待竣工</div> -->
      <div v-if="isLabelNum == 5" class="option-item selected">已完工</div>
      <div v-if="isLabelNum != 5" class="option-item" @click="isLabel(5)">已完工</div>
    </div>
    <div v-if="projectList.length!=0">
      <div class="case-list">
        <div class="case-item" v-for="project in projectList" @click="openProjectDetail(project)">
          <img v-if="project.cover" :src="project.cover  | ossProcess(690, 320)">
          <img v-if="!project.cover && project.type != '1'" src="../../assets/icon-project-default-cover.png">
          <img v-if="!project.cover && project.type == '1'" src="../../assets/icon-supervisor-case-cover.png">
          <div class="project-info">
            <div class="name">{{project.name | projectNameConvert}}</div>
            <div class="house-layout">{{project.houseLayout}}  |  {{project.area}}㎡</div>
            <div class="project-type">{{ project.projectTypeName }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="black-page" v-if="projectList.length==0">
      <img src="../../assets/icon-no-img.png">
      <div class="tip">暂无相关项目</div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import ProjectService from '../../service/customer/ProjectService'
  import {imgUrl} from "../../config";

  export default {
    name: 'MineProject',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        isLabelNum:4,
        projectStatus:4,
        projectList:[],
        isWechatBrowser:this.$verfyBrowserType(),
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      if (this.global.labelSelected) {
        this.labelNum = this.global.labelSelected;
        this.global.labelSelected = '';
        this.isLabel(this.labelNum);
      } else {
        this.getProjectList();
      }
    },
    methods: {
      isLabel(num){
        if(num == 4){
          this.isLabelNum=4;
          this.projectStatus=4;
          this.projectList = [];
          this.getProjectList();
        }else if(num == 5){
          this.isLabelNum=5;
          this.projectStatus=5;
          this.projectList = [];
          this.getProjectList();
        }else {
          this.isLabelNum=8;
          this.projectStatus=8;
          this.projectList = [];
          this.getProjectList();
        }
      },
      openProjectDetail(project){
        this.global.labelSelected = this.isLabelNum;
        console.info(project.companyId);
        const inLight = this.$route.query.inLight;
        if (inLight) {
          if(!project.companyId && project.projectTypeName == "工长"){
            const h5Url = `/foreman/project/detail?id=${project.customerProjectId}&onestopProjectId=${project.id}&type=${project.type}&projectName=${project.name}`
            wx.miniProgram.navigateTo({
              url: `/pages/h5/webview/index?path=${encodeURIComponent(h5Url)}&nbBackgroundColor=#C4A183`,
            })
          } else if(!project.companyId){
            const h5Url = `/linked/project/detail?id=${project.customerProjectId}&onestopProjectId=${project.id}&type=${project.type}&projectName=${project.name}`
            wx.miniProgram.navigateTo({
              url: `/pages/h5/webview/index?path=${encodeURIComponent(h5Url)}&nbBackgroundColor=#384157`,
            })
          } else {
            const h5Url = `/onestop/project/detail?id=${project.customerProjectId}&onestopProjectId=${project.id}&type=${project.type}&projectName=${project.name}`
            wx.miniProgram.navigateTo({
              url: `/pages/h5/webview/index?path=${encodeURIComponent(h5Url)}&nbBackgroundColor=#FEAC00`,
            })
          }
        } else {
          if (!project.companyId && project.projectTypeName == "工长") {
            this.$router.push({name:'ForemanProjectDetail',query:{id:project.customerProjectId,onestopProjectId:project.id,type:project.type,projectName:project.name}});
          } else if(!project.companyId){
            this.$router.push({name:'LinkedProjectDetail',query:{id:project.customerProjectId,onestopProjectId:project.id,type:project.type,projectName:project.name}});
          }else{
            this.$router.push({name:'OnestopProjectDetail',query:{id:project.customerProjectId,onestopProjectId:project.id,type:project.type,projectName:project.name}});
          }
        }
      },
      async getProjectList(){
        var result = await ProjectService.getOnestopProjectList('1','','','','',this.projectStatus);
        if(result.code == '0'){
          this.projectList = result.data.result;
          for(let project of this.projectList){
            console.info(project)
            if(project.cover){
              let cover = imgUrl + project.cover;
              project.cover = cover;
            }
            if(project.type == '6'){
              if(project.renderings){
                let renderingsArray = project.renderings.split(',');
                project.cover = imgUrl + renderingsArray[0];
              }
            }
            let projectTypeName = '';
            console.info(project);
            if(project.type != '5'){
              if(project.foremanId && project.supervisorId && !project.designerId){
                projectTypeName = '工长 + 监理';
                this.$set(project,'type',7);
              }else if(project.foremanId && project.supervisorId && project.designerId){
                projectTypeName = '工长 + 监理 + 设计师';
                this.$set(project,'type',7);
              }else if(project.foremanId && project.designerId){
                projectTypeName = '工长 + 设计师';
                this.$set(project,'type',7);
              }else if(project.supervisorId && project.designerId){
                projectTypeName = '监理 + 设计师';
                this.$set(project,'type',7);
              }else if(project.foremanId){
                projectTypeName = '工长';
                this.$set(project,'type',2);
              }else if(project.supervisorId){
                projectTypeName = '监理';
                this.$set(project,'type',1);
              }else if(project.designerId){
                projectTypeName = '设计师';
                this.$set(project,'type',6);
              }
            }else{
              projectTypeName = '整包';
            }
            this.$set(project,'projectTypeName',projectTypeName);
          }
        }else {
          Toast('获取项目列表失败');
        }
      },
    }
  }
</script>

<style lang="scss">
  @import '../../assets/style/case-list.scss';
  .clear-header{
    margin-top: -1rem;
  }
  .mine-project{
    background: white;
    font-size: 0.3rem;
    .clear-header{
      margin-top: -1rem;
    }
  }
  .black-page{
    height: 100vh;
    text-align: center;
    img{
      width: 1.57rem;
      height: 1.57rem;
      margin-top: 2.32rem;
    }
    .tip{
      margin-top: 0.4rem;
      font-size: 0.32rem;
      color: #7f7d7c;
    }
  }
  .option-labels{
    display: flex;
    margin-top: 0.1rem;
    margin-left: 0.32rem;
    margin-right: 0.32rem;
    padding-left: 0.32rem;
    padding-right: 0.32rem;
    font-weight: bold;
    .option-item{
      height: 0.88rem;
      line-height: 0.9rem;
      font-size: 0.34rem;
      color: #999;
    }
    .selected{
      position: relative;
      color: #333;
    }
    .selected:after{
      content: '';
      position: absolute;
      top: 0.8rem;
      left: 25%;
      bottom: 0;
      right: 0;
      width: 0.5rem;
      height: 0.08rem;
      background-color: #333;
    }
  }
</style>
